import { Button } from "antd";
import { useHistory } from "react-router";
import { InfoIcon } from "../../atoms/icon";
import "./access-denied-wrapper.scss";

const AccessDenied = () => {

    const history = useHistory();

    const goback = () => {
        history.goBack();
    }

    return (
        <div className="access-denied-wrapper">
            <InfoIcon />
            <p className="title">
                You do not have permission to access this function
            </p>
            <Button type="primary" shape="round" onClick={goback} >
                Go back
            </Button>
        </div>
    )
}

export default AccessDenied;